<template>
  <div>
    <tabAdvertisements />

    <div v-if="banners.length">
      <DsmarketBanner
        v-for="banner in banners"
        :key="banner.id"
        :banners="banner"
      ></DsmarketBanner>
    </div>
  </div>
</template>
<script>
import DsmarketBanner from "./components/DsmarketBanner";
import tabAdvertisements from "./tabAdvertisements";

//import Carousel from '../advertisements/Carousel';
import { mapState } from "vuex";

export default {
  components: {
    tabAdvertisements,
    DsmarketBanner
  },
  data() {
    return {
      images: [
        {
          id: "1",
          big:
            "https://s.alicdn.com/@img/tfs/TB1gBlJRRr0gK0jSZFnXXbRRXXa-1920-565.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020162241_4yQeJbv59p.jpg"
        },
        {
          id: "2",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020135308_qteV1MVJwY.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020162724_DriX6A1Ump.jpg"
        },
        {
          id: "3",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020135334_ojgFuccbGw.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020162707_reyseoKRds.jpg"
        },
        {
          id: "4",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020135236_9YpUITwBj7.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020162741_yj7NhtYQMl.jpg"
        }
      ],

      imagesfooter: [
        {
          id: "1",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020192032_6PS9g5UEVx.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020191828_MyrhN7gjAd.jpg"
        },
        {
          id: "2",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020190937_S9xGIiYMiJ.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020191040_NdRSNJ3IDh.jpg"
        },
        {
          id: "3",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020191021_ERA4DtZ9Gc.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020191139_mwLnYNKntW.jpg"
        },

        {
          id: "4",
          big:
            process.env.BASE_URL + "assets/uploads/05Dec2020191004_oGcuBZOBhr.jpg",
          thumb:
            process.env.BASE_URL + "assets/uploads/05Dec2020191100_V4eGWUf0W2.jpg"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      banners: state => state.profile.banners
    })
  },
  methods: {
    getHomeBanner() {
      const data = {
        page: 1,
        type: "market"
      };
      this.$store
        .dispatch("GET_BANNER_ADDS", data)
        .then(res => console.log(res));
    }
  },
  created() {
    this.getHomeBanner();
  }
};
</script>

<style scoped>
.wrapper_order_table {
  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  background-color: #fff;
  border-radius: 6px;
  padding: 25px;
  margin-bottom: 20px;
}

.wrapper_order_table h3 {
  color: #535559;
  font-size: 13px;
  font-weight: 400;
  margin-top: 0px;
  line-height: 17px;
}
.wrapper_order_table strong {
  color: #ff5722;
  margin-left: 2px;
}
.add_btn {
  width: 38px;
  height: 36px;
  float: left;
  background-color: #fff;
  margin-top: 2px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #ff5722;
  margin-left: 2px;
  border: dashed 1px #ff5722;
}
.carousel_adevertisement {
  position: relative;
}

.big_img_add {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 9;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: dashed 1px #ff5722;
  display: none;
}

.big_img_add i {
  color: #ff5722;
  font-size: 50px;
  cursor: pointer;
}
.badge_number {
  background-color: #ff5722;
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 3px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 12px;
  margin-right: 8px;
  line-height: 2px;
}

.prltve {
  position: relative;
}
.box_home_advertisement {
  float: left;
}
.count-down {
  position: absolute;
  top: 18px;
  right: 8px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 5px;
  padding-bottom: 4px;
}
.dot_label_active {
  background: #64dd17;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  float: left;
  margin: 1px 5px 0px 0px;
}
.dot_label_inactive {
  background: #f44336;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  float: left;
  margin: 1px 5px 0px 0px;
}
.label_active {
  background: rgba(0, 0, 0, 0.55);

  color: #fff;
  padding: 6px 10px;
  border-radius: 3px;
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 12px;
  padding-top: 8px;
}

.label_inactive {
  background: rgba(0, 0, 0, 0.55);

  color: #fff;
  padding: 6px 10px;
  border-radius: 3px;
  float: left;
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  right: 80px;
  font-size: 12px;
  padding-top: 8px;
}

.pay_now {
  background: #ff5722;
  color: #fff;
  padding: 6px 10px;
  border-radius: 3px;
  float: left;
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 12px;
  padding-top: 8px;
}

.wrap_count-down {
  float: left;
  margin-right: 5px;
}
.wrap_count-down h3 {
  text-align: center;
  font-size: 10px;
  color: #fff;
  margin-top: 1px;
}
.box_count-down {
  background-color: #ff5722;
  border-radius: 5px;
  width: 42px;
  height: 34px;

  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  line-height: 1px;
}

.box_home_advertisement img {
  width: 100%;
  margin-top: 10px;
  height: 136px;
}
.row_box_adver {
  margin-left: 0px;
  margin-right: -15px;
}
.addbox_advertisement {
  display: flex;
  align-items: center;
  color: #ff5722;
  justify-content: center;
  margin-top: 10px;
  height: 136px;
  border: dashed 1px #ff5722;
  float: left;
  width: 100%;
}

.addbox_advertisement i {
  cursor: pointer;
}
.addbox_right_two {
  height: 207px;
}
.addbox_row_two img {
  height: 207px;
}
@media screen and (max-width: 768px) {
  .wrapper_order_table h3 {
    color: #535559;
    font-size: 11px;
    line-height: 15px;
  }

  .tab_width h3 {
    width: 89%;
  }
  .badge_number {
    margin-bottom: 10px;
  }
  .box_home_advertisement img,
  .addbox_advertisement {
    height: 68px;
  }

  .addbox_row_two img,
  .addbox_right_two {
    height: 105px;
  }

  .wrap_count-down h3 {
    color: white;
    font-size: 8px;
  }

  .box_count-down {
    width: 36px;
    height: 21px;
    color: #fff;
    font-size: 11px;
  }
  .wrap_count-down {
    float: left;
    margin-right: 3.2px;
  }
  .count-down {
    padding: 4px;
    padding-bottom: 0px;
    top: 14px;
    right: 4px;
  }

  .label_active {
    padding: 4px 5px;
    position: absolute;
    bottom: 3px;
    right: 4px;
    font-size: 9px;
    padding-top: 5px;
  }

  .label_inactive {
    padding: 4px 5px;
    position: absolute;
    bottom: 3px;
    right: 56px;
    font-size: 9px;
    padding-top: 5px;
  }
  .pay_now {
    background: #ff5722;
    color: #fff;
    padding: 4px 5px;

    position: absolute;
    bottom: 3px;
    right: 4px;
    font-size: 9px;
    padding-top: 5px;
  }

  .dot_label_active,
  .dot_label_inactive {
    width: 6px;
    height: 6px;
    margin: 1px 4px 0px 0px;
  }
}

@media screen and (max-width: 600px) {
  .wrapper_order_table {
    padding: 10px;
  }

  .box_home_advertisement img,
  .addbox_advertisement {
    height: 135px;
  }

  .addbox_row_two img,
  .addbox_right_two {
    height: 175px;
  }

  .box_home_advertisement img {
    margin-bottom: 3px;
    margin-top: 7px;
  }
  .wrapper_order_table h3 {
  }
  .addbox_advertisement {
    margin-top: 7px;
  }

  .box_count-down {
    width: 40px;
    height: 34px;
    font-size: 12px;
  }

  .wrap_count-down h3 {
    font-size: 9px;
  }
  .wrap_count-down {
    margin-right: 5px;
  }

  .count-down {
    padding: 6px;
    top: 14px;
    right: 7px;
    padding-bottom: 4px;
  }
  .label_active {
    padding: 6px 10px;
    position: absolute;
    bottom: 10px;
    right: 7px;
    font-size: 11px;
    padding-top: 7px;
  }

  .dot_label_active,
  .dot_label_inactive {
    margin: 2px 4px 0px 0px;
  }

  .label_inactive {
    padding: 6px 10px;
    position: absolute;
    bottom: 10px;
    right: 80px;
    font-size: 11px;
    padding-top: 7px;
  }

  .pay_now {
    padding: 6px 10px;
    position: absolute;
    bottom: 10px;
    right: 7px;
    font-size: 11px;
    padding-top: 7px;
  }
}

@media screen and (max-width: 300px) {
  .wrapper_order_table h3 {
    font-size: 10px;
    line-height: 14px;
  }

  .box_home_advertisement img,
  .addbox_advertisement {
    height: 97px;
  }

  .addbox_row_two img,
  .addbox_right_two {
    height: 97px;
  }

  .box_home_advertisement img {
    margin-top: 5px;
  }

  .addbox_advertisement {
    margin-top: 5px;
  }

  .count-down {
    padding: 6px;
    top: 10px;
    right: 5px;
    padding-bottom: 4px;
  }

  .label_active {
    padding: 6px 10px;
    position: absolute;
    bottom: 8px;
    right: 5px;
    font-size: 11px;
    padding-top: 7px;
    font-size: 10px;
  }

  .box_count-down {
    width: 42px;
  }

  .label_inactive {
    bottom: 8px;
    right: 73px;
    font-size: 10px;
  }

  .pay_now {
    right: 5px;
    font-size: 10px;
    bottom: 8px;
  }

  .dot_label_active,
  .dot_label_inactive {
    margin: 1px 4px 0px 0px;
  }
  .wrap_count-down h3 {
    font-size: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/profileDashboard/vendor/advertisements/dsMarketPage.vue